/** Ant Select inside Modal: render dropdown above modal mask so options are visible. */
export function selectModalPopupContainer(trigger) {
    if (trigger && typeof trigger.closest === 'function') {
        const node = trigger.closest('.ant-modal-content');
        if (node) return node;
    }
    return document.body;
}
